import React, { useEffect, useState, useRef } from "react";
import Leftpanel from "../layout/Leftpanel";
import Header from "../layout/Header";
import { Link, useLocation, useNavigate } from "react-router-dom";
import instance from "../../../WebApi/WebApi";
import { toast } from "react-toastify";
import {
  Form,
  Tooltip,
  OverlayTrigger,
  Modal,
  Nav,
  Dropdown,
} from "react-bootstrap";
import { getAllGHGlist } from "../../../service/ghg/ghgService";
import { FUEL_TYPE, MATERIAL_TYPE, TRANSPORT_TYPE } from "../utils/constant";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
  getAccountingInformation,
  getAnswer,
  getAnswerPurchase,
  getEditPurchaseOrder,
} from "../../../service/PastOrder/PastOrderService";
import { listDepartmentByBusinessId } from "../../../service/Department/DepartmentService";
import { getAllIndustryDetailslist } from "../../../service/BusinessUnit/BusinessUnitService";
import SpinnerComponent from "../../components/SpinnerComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Purchaseorderdetail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const purchaseId = new URLSearchParams(location.search).get("id");
  const [isLoading, setIsLoading] = useState(false);
  const [purchadeOrderData, setPurchaseOrderData] = useState();
  const [ghgData, setGhgData] = useState("");
  const [ghgList, setGhgList] = useState([]);
  const [glData, setGlData] = useState("");
  const [fstartDate, setFStartDate] = useState();
  const [emissionData, setEmissionData] = useState([
    { transport_type: "", transport_fuel: "", transport_distance: "" },
  ]);
  const [wasteData, setWasteData] = useState([
    { material_type: "", quantity: "" },
  ]);
  const [allData, setAllData] = useState();
  const [logs, setLogs] = useState(false);
  const [activeTab, setActiveTab] = useState("link-2");
  const [allLogs, setAllLogs] = useState();
  const [status, setStatus] = useState("");
  const [departmentId, setDepartmentId] = useState("");
  const [accoutingInfoType, setAccoutingInfoType] = useState("businessUnit");
  const [accountingInformation, setAccountingInformation] = useState([]);
  const [businessUnitNameId, setBusinessUnitNameId] = useState("");
  const [comments, setComments] = useState("");
  const [commentk, setCommentEdit] = useState("");
  const [departmentList, setDepartmentList] = useState([]);
  const [businessList, setAllBusinessList] = useState([]);
  const [startDate, setStartDate] = useState();
  const datePickerRef = useRef(null);
  const timePickerRef = useRef(null);
  const [isAccordionOpen, setIsAccordionOpen] = useState(false);

  const handleCloseLogs = () => (setLogs(false), setActiveTab("link-2"));
  const handleIconClick = () => {
    if (datePickerRef.current) {
      datePickerRef.current.setFocus(); // Opens the date picker
    }
  };
  const handleTimeIconClick = () => {
    if (timePickerRef.current) {
      timePickerRef.current.setFocus(); // Opens the date picker
    }
  };

  useEffect(() => {
    if (purchaseId) {
      getPurchaseOrderById();
      getGHGDataList();
      _FETCH_ACCOUTING_INFO();
      getDepartmentList();
      getAllLogs();
    }
  }, [purchaseId]);

  const getPurchaseOrderById = async () => {
    const data = {
      purchaseOrderId: purchaseId,
    };
    try {
      const response = await instance.post(
        `/customer/purchase-order/past-order-details`,
        data
      );
      setPurchaseOrderData(response?.data?.data);
      setGhgData(JSON.stringify(response?.data?.data?.GHG_Key));
      setGlData(JSON.stringify(response?.data?.data.GL));
      setWasteData(
        response?.data?.data?.wastePackageMaterial || [
          { material_type: "", quantity: "" },
        ]
      );
      setEmissionData(
        response?.data?.data?.transportEmission || [
          { transport_type: "", transport_fuel: "", transport_distance: "" },
        ]
      );
      setStatus(response?.data?.data?.orderStatus);
      setDepartmentId(response?.data?.data?.departmentId);
      listDepartmentByBusinessId(
        response?.data?.data?.businessUnitId,
        (res) => {
          setDepartmentList(res.data.departmentList);
        }
      );
      if (response?.data?.data?.deliveryDateTime) {
        setStartDate(new Date(response?.data?.data?.deliveryDateTime));
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    }
  };

  const _FETCH_ACCOUTING_INFO = async () => {
    setIsLoading(true);
    getAccountingInformation(purchaseId, (res) => {
      setAccountingInformation(res.data.products);

      setIsLoading(false);
    });
  };

  async function getDepartmentList() {
    setIsLoading(true);
    getAllIndustryDetailslist().then((res) => {
      // console.log(res.data.data,"resData");
      const response = res.data.data;
      setAllBusinessList(response);
      setIsLoading(false);
    });
  }

  async function getGHGDataList() {
    setIsLoading(true);
    getAllGHGlist().then(function (result) {
      const response = result?.data;
      setGhgList(response?.data?.ghgList);

      setIsLoading(false);
    });
  }

  const getAllLogs = async () => {
    const data = {
      purchaseOrderId: purchaseId,
    };
    setIsLoading(true);
    try {
      const response = await instance.post(
        `/customer/purchase-order/get-purchase-order-logs`,
        data
      );
      if (response?.data?.success) {
        setAllLogs(response?.data?.data?.orderLogs);
        const commentData =
          response?.data?.data?.orderLogs?.commentPurchaseLogs;
        setCommentEdit(commentData[commentData.length - 1]?.comments);
        setComments(commentData[commentData.length - 1]?.comments);
        setIsLoading(false);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
      setIsLoading(false);
    }
  };

  const sortedData = ghgList.sort((a, b) => {
    if (a.key < b.key) return -1;
    if (a.key > b.key) return 1;
    return 0;
  });

  const handleTransportEmission = (index, e) => {
    const { name, value } = e.target;
    const updatedData = [...emissionData];
    updatedData[index] = {
      ...updatedData[index],
      [name]: value,
    };
    setEmissionData(updatedData);
  };

  const handleAddTransport = () => {
    setEmissionData([
      ...emissionData,
      { transport_type: "", transport_fuel: "", transport_distance: "" },
    ]);
  };

  const handleRemoveTransport = (id) => {
    const updatedData = emissionData.filter((_, i) => i !== id); // Remove entry by index
    setEmissionData(updatedData);
  };

  const handleAddWaste = () => {
    setWasteData([...wasteData, { material_type: "", quantity: "" }]);
  };
  const handleWasteMaterial = (index, e) => {
    const { name, value } = e.target;
  //  console.log(name);
    const updatedData = [...wasteData];
    updatedData[index] = {
      ...updatedData[index],
      [name]: value,
    };
    setWasteData(updatedData);
  };
  const handleRemoveWaste = (id) => {
    const updatedData = wasteData.filter((_, i) => i !== id);
    setWasteData(updatedData);
  };

  const handleToggle = (e, qualityControlId) => {
    const value = e.target.value; // Convert the string to a boolean

    setAllData((prevState) => ({
      ...prevState,
      [qualityControlId]: {
        answer: value,
        qualityControlId: qualityControlId,
        pastOrderId: purchaseId,
      },
    }));
  };
  const handleSelect = async (eventKey) => {
  //  console.log("eventKey", eventKey);
    // setIsLoading(true);

    // Map the event keys to their respective URLs
    const urlMap = {
      // "link-1": "/customer/purchase-order/get-purchase-order-logs",
      "link-2": "/customer/purchase-order/get-purchase-order-comment-logs",
      "link-3": "/customer/purchase-order/get-purchase-order-order-logs",
      // "link-4": "/customer/purchase-order/get-purchase-order-quantity-logs",
      "link-5": "/customer/purchase-order/get-purchase-order-business-logs",
      "link-6": "/customer/purchase-order/get-purchase-order-ghg-logs",
      "link-7": "/customer/purchase-order/get-purchase-order-delivery-logs",
    };
    const url = urlMap[eventKey];

    if (!url) {
      console.error("Invalid eventKey provided.");
      return;
    }

    // Prepare the data payload
    const data = {
      purchaseOrderId: purchaseId,
    };

    try {
      // Call the API using the selected URL
      const response = await instance.post(url, data);
    //  console.log("response", response);
      setAllLogs(response?.data?.data?.pastOrderDetails);

      // Set the active tab if API call is successful
      setActiveTab(eventKey);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error("Error in API call", error);
    }
  };

  const _CHECK_PERMISION = (moduleType) => {
    return JSON.parse(
      localStorage.getItem("gs3_User")
    ).UserJobRole?.AssignRoleModules.some(
      (item) => item.modulename === moduleType
    );
  };

  const onStatus = (e) => {
    setStatus(e.target.value);
  };

  const _SET_DEPT_ID = (e) => {
    setDepartmentId(e.target.value);
    setAccoutingInfoType("department");
  };

  const onBusinessUnitName = (e) => {
    setDepartmentId("");
    setAccoutingInfoType("businessUnit");
    setBusinessUnitNameId(e.target.value);
    listDepartmentByBusinessId(e.target.value, (res) => {
      setDepartmentList(res.data.departmentList);
    });
  };

  let businessUnitDropdown = <option>Loading...</option>;
  if (businessList && businessList.length > 0) {
    businessUnitDropdown = businessList.map((businessRow, index) => (
      <option
        value={businessRow.id}
        selected={businessRow.id === purchadeOrderData?.businessUnitId}
      >
        {businessRow.name}
      </option>
    ));
  }

  const qcSubmit = () => {
    const QCAnser = [];
    Object.values(allData).map((data) => QCAnser.push(data));

    const data = {
      QCAnser: QCAnser,
    };
    getAnswerPurchase(data, (r) => {
      if (r.success === true) {
        // toast.success(r.message)
        navigate("/purchaseorder");
      } else {
        toast.error(r.message);
      }
    });
  };

  const onUpdate = () => {
    setIsLoading(true);
  //  console.log("ghg", JSON.parse(ghgData));
    getEditPurchaseOrder(
      purchaseId,

      businessUnitNameId === purchadeOrderData?.businessUnitId
        ? ""
        : businessUnitNameId,
      commentk,
      purchadeOrderData?.invoiceId,
      status === purchadeOrderData?.orderStatus ? null : status,
      JSON.parse(ghgData)?.id === purchadeOrderData?.GHG_Key?.id
        ? null
        : ghgData,
      // JSON.parse(glData)?.id === purchadeOrderData?.GL?.id ? null : glData,
      departmentId === purchadeOrderData?.departmentId ? "" : departmentId,
      fstartDate,
      emissionData,
      wasteData,

      (r) => {
        if (r.success === true) {
          setIsLoading(false);
          toast.success(r.message);
          setBusinessUnitNameId("");
          setCommentEdit("");
          setStatus("");
          setGhgData("");
          setGlData("");
          setDepartmentId("");
          setFStartDate();
          getPurchaseOrderById();
          getGHGDataList();
          _FETCH_ACCOUTING_INFO();
          getDepartmentList();
          getAllLogs();
          // navigate("/pastorder");
        } else {
          setIsLoading(false);
          toast.error(r.message);
        }
      }
    );
    if (allData) {
      qcSubmit();
    }
  };

  const totalamountCalculate = (amount, vat) => {
    const percentage = (vat / 100) * amount;
    const ramain = amount - percentage;
    return ramain;
  };

  const toggleAccordion = () => {
    setIsAccordionOpen(!isAccordionOpen);
  };

  return (
    <div className="container-fluid">
      <div className="dbMain purchase">
        <Leftpanel />
        <div className="dbRight">
          <Header
            link="/purchaseorder"
            breadcm=""
            title="Purchase Order Details"
            description=""
          />
          <div className="commonBase mb-3">
            <span className="editOrdricon">
              <Link to="">
                <i className="fa-light fa-pen"></i>
              </Link>
            </span>
            <div className="row orderDetl">
              <div className="col-md-6">
                <h5>Demo Company</h5>
                <p>{purchadeOrderData?.Supplier?.address}</p>
                <p>Telephone - {purchadeOrderData?.Supplier?.mobile}</p>
                <p>Website: - {purchadeOrderData?.Supplier?.website}</p>
                <h6>
                  {t("business_units")}: -{" "}
                  <i className="fa-solid fa-circle-check"></i>
                  <select
                    name=""
                    id=""
                    onChange={onBusinessUnitName}
                    className="poEdit"
                    style={{ maxWidth: "inherit" }}
                  >
                    <option value="">{t("select_operating_units")}</option>
                    {businessUnitDropdown}
                  </select>
                </h6>
                <h6>
                  {t("department")}: -{" "}
                  <i className="fa-solid fa-circle-check"></i>
                  <select
                    name=""
                    id=""
                    onChange={_SET_DEPT_ID}
                    className="poEdit"
                    style={{ maxWidth: "inherit" }}
                  >
                    <option value="">{t("select_departments")}</option>
                    {departmentList.length > 0 &&
                      departmentList.map((item, index) => {
                        return (
                          <option
                            value={item.id}
                            key={item.id}
                            selected={
                              item.id === purchadeOrderData?.departmentId
                            }
                          >
                            {item.name}
                          </option>
                        );
                      })}
                  </select>
                </h6>
              </div>
              {isLoading && <SpinnerComponent isLoading={isLoading} />}
              <div className="col-md-6">
                <h5>{t("order")}</h5>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <h6 style={{ marginRight: "10px" }}>Delivery Date:</h6>
                  <DatePicker
                    ref={datePickerRef}
                    selected={startDate}
                    onChange={(date) => (
                      setStartDate(date), setFStartDate(date)
                    )}
                    dateFormat="dd/MM/yyyy"
                    placeholderText="Select a date"
                    className="supplierEditInput"
                    style={{ marginRight: "10px" }}
                  />
                  <i
                    className="fa fa-calendar-alt calendar-icon"
                    onClick={handleIconClick}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      left: "235px",
                    }}
                  ></i>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    position: "relative",
                  }}
                >
                  <h6>Delivery Time: </h6>
                  <DatePicker
                    ref={timePickerRef}
                    selected={startDate}
                    onChange={(date) => (
                      setStartDate(date), setFStartDate(date)
                    )}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15} // Interval between time options
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    placeholderText="Select a time"
                    className="supplierEditInput"
                  />
                  <i
                    className="fa fa-clock calendar-icon"
                    onClick={handleTimeIconClick}
                    style={{
                      cursor: "pointer",
                      position: "absolute",
                      left: "235px",
                    }}
                  ></i>
                </div>

                <h6>Order ID: - {purchadeOrderData?.id}</h6>
                <h6>
                  Invoice ID: -{purchadeOrderData?.invoiceId}
                  <Link
                    to={`/invoicedetails?id=${purchadeOrderData?.orginalInvoiceId}`}
                  >
                    {purchadeOrderData?.Invoice?.invoice?.Invoice?.ID?._text}
                  </Link>
                </h6>
                <h6>
                  Order Status: - <i className="fa-solid fa-circle-check"></i>
                  <select
                    name=""
                    id=""
                    onChange={onStatus}
                    className="poEdit"
                    style={{ maxWidth: "inherit" }}
                  >
                    <option value="">{t("selectStatus")}</option>
                    {_CHECK_PERMISION("Orders") &&
                      !(
                        _CHECK_PERMISION("PastOrder Approved with Issues") ||
                        _CHECK_PERMISION("PastOrder Approved") ||
                        _CHECK_PERMISION("PastOrder Received with Issues") ||
                        _CHECK_PERMISION("PastOrder Received")
                      ) && (
                        <>
                          <option
                            value="Created"
                            selected={status === "Created"}
                          >
                            {t("created")}
                          </option>
                        </>
                      )}
                    {_CHECK_PERMISION("Orders") &&
                      !(
                        _CHECK_PERMISION("PastOrder Approved with Issues") ||
                        _CHECK_PERMISION("PastOrder Approved")
                      ) && (
                        <>
                          <option
                            value="Received,comments"
                            selected={status === "Received,comments"}
                          >
                            {t("receivedWithIssues")}
                          </option>
                          <option
                            value="Received"
                            selected={status === "Received"}
                          >
                            {t("received")}
                          </option>
                        </>
                      )}
                    {_CHECK_PERMISION("Orders") &&
                      !(
                        _CHECK_PERMISION("PastOrder Received with Issues") ||
                        _CHECK_PERMISION("PastOrder Received")
                      ) && (
                        <>
                          <option
                            value="Approved,comments"
                            selected={status === "Approved,comments"}
                          >
                            {t("approvedWithComments")}
                          </option>
                          <option
                            value="Approved"
                            selected={status === "Approved"}
                          >
                            {t("approved")}
                          </option>
                        </>
                      )}
                    {_CHECK_PERMISION("Orders") &&
                      !(
                        _CHECK_PERMISION("PastOrder Approved with Issues") ||
                        _CHECK_PERMISION("PastOrder Approved") ||
                        _CHECK_PERMISION("PastOrder Received with Issues") ||
                        _CHECK_PERMISION("PastOrder Received")
                      ) && (
                        <>
                          <option
                            value="Rejected"
                            selected={status === "Rejected"}
                          >
                            {t("rejected")}
                          </option>
                        </>
                      )}

                    {_CHECK_PERMISION("PastOrder Approved with Issues") &&
                      _CHECK_PERMISION("PastOrder Approved") &&
                      _CHECK_PERMISION("PastOrder Received with Issues") &&
                      _CHECK_PERMISION("PastOrder Received") &&
                      _CHECK_PERMISION("Orders") &&
                      _CHECK_PERMISION("Configuration") &&
                      _CHECK_PERMISION("Invoices") &&
                      _CHECK_PERMISION("Products") &&
                      _CHECK_PERMISION("Suppliers") &&
                      _CHECK_PERMISION("Reports") &&
                      _CHECK_PERMISION("Business Unit") &&
                      _CHECK_PERMISION("Department") &&
                      _CHECK_PERMISION("Users") && (
                        <>
                          <option
                            value="Created"
                            selected={status === "Created"}
                          >
                            {t("created")}
                          </option>
                          <option
                            value="Received,comments"
                            selected={status === "Received,comments"}
                          >
                            {t("receivedWithIssues")}
                          </option>
                          <option
                            value="Received"
                            selected={status === "Received"}
                          >
                            {t("received")}
                          </option>
                          <option
                            value="Approved,comments"
                            selected={status === "Approved,comments"}
                          >
                            {t("approvedWithIssues")}
                          </option>
                          <option
                            value="Approved"
                            selected={status === "Approved"}
                          >
                            {t("approved")}
                          </option>
                          <option
                            value="Rejected"
                            selected={status === "Rejected"}
                          >
                            {t("rejected")}
                          </option>
                        </>
                      )}
                  </select>
                </h6>
              </div>
            </div>
            <div className="row ordervendor">
              <div className="col-md-6">
                <h6>Vendor</h6>
                <div className="pd">
                  <span className="pdn">Company Name :</span>{" "}
                  <span>{purchadeOrderData?.Supplier?.name}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Contact or Department :</span>{" "}
                  <span>
                    {
                      departmentList?.find(
                        (data) => data?.id === purchadeOrderData?.departmentId
                      )?.name
                    }
                  </span>
                </div>
                <div className="pd">
                  <span className="pdn">Address Line 1 :</span>{" "}
                  <span>{purchadeOrderData?.Supplier?.city}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Address Line 2 :</span>{" "}
                  <span>{purchadeOrderData?.Supplier?.address}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Phone :</span>{" "}
                  <span>{purchadeOrderData?.Supplier?.mobile}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Email :</span>{" "}
                  <span>{purchadeOrderData?.Supplier?.email}</span>
                </div>
              </div>
              <div className="col-md-6">
                <h6>Ship to</h6>
                <div className="pd">
                  <span className="pdn">Name :</span>{" "}
                  <span>{`${purchadeOrderData?.User?.firstName} ${purchadeOrderData?.User?.lastName}`}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Company Name :</span>{" "}
                  <span>{purchadeOrderData?.User?.companyName}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Address Line 1 :</span>{" "}
                  <span>{purchadeOrderData?.User?.city}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Address Line 2 :</span>{" "}
                  <span>{purchadeOrderData?.User?.address}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Phone :</span>{" "}
                  <span>{purchadeOrderData?.User?.phone}</span>
                </div>
                <div className="pd">
                  <span className="pdn">Email :</span>{" "}
                  <span>{purchadeOrderData?.User?.email}</span>
                </div>
              </div>
            </div>

            <div className="poTable">
              <table>
                <tr>
                  <th>Id</th>
                  <th>Name</th>
                  <th>QTY</th>
                  <th>CARBON FOOTPRINT</th>
                  <th>UNSPSC</th>
                  <th>UNIT PRICE</th>
                  <th>DISCOUNT</th>
                  <th>TOTAL</th>
                </tr>
                {purchadeOrderData?.pastOrderProducts?.length !== 0 ? (
                  purchadeOrderData?.pastOrderProducts?.map((d, i) => (
                    <tr key={i}>
                      <td>{d?.productId}</td>
                      <td>{d?.productName}</td>
                      <td>{d?.quantity}</td>
                      <td>{d?.CarbonFootPrint}</td>
                      <td
                        className="pointer"
                        data-label="Product UNSPSC"
                        style={{ textAlign: "center" }}
                      >
                        {d?.Product?.unspscTitle ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={
                              <Tooltip
                                id={`tooltip-${d?.Product?.unspscTitle}`}
                                style={{ fontSize: "10px" }}
                              >
                                {d?.Product?.unspscTitle}
                              </Tooltip>
                            }
                          >
                            <span>
                              {`${d?.Product?.unspscTitle?.slice(0, 10)}${
                                d?.Product?.unspscTitle?.length > 10
                                  ? "..."
                                  : ""
                              }`}
                            </span>
                          </OverlayTrigger>
                        ) : (
                          "-"
                        )}
                      </td>
                      <td>Íkr {d?.unitPrice}</td>
                      <td>{d?.discount}</td>
                      <td>Íkr {d?.totalAmount}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} style={{ textAlign: "center" }}>
                      No product added
                    </td>
                  </tr>
                )}
              </table>
            </div>

            <div className="row">
              <div className="col-md-4 order-md-1">
                <div className="subtotal">
                  <h6>Subtotal: </h6>{" "}
                  <span>{purchadeOrderData?.totalAmount || 0}</span>
                </div>
                <div className="subtotal">
                  <h6>Tax: </h6>{" "}
                  <span className="boxborder">
                    {purchadeOrderData?.totalVat}%
                  </span>
                </div>
                <div className="subtotal">
                  <h6>Shipping: </h6> <span className="boxborder">---</span>
                </div>
                <div className="subtotal">
                  <h6>Other: </h6> <span className="boxborder">---</span>
                </div>
                <div className="subtotal">
                  <h6>
                    <strong>Total:</strong>{" "}
                  </h6>{" "}
                  <span className="boxborder totl">
                    Íkr{" "}
                    {totalamountCalculate(
                      purchadeOrderData?.totalAmount,
                      purchadeOrderData?.totalVat
                    )}
                  </span>
                </div>
              </div>
              <div className="col-md-8">
                <table className="instruction">
                  <tr>
                    <th>Comments or Special Instructions</th>
                  </tr>
                  <tr>
                    <td>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        placeholder="Comments & special instructions"
                        className="comnt"
                        name="comments"
                        defaultValue={comments}
                        onChange={(e) => setCommentEdit(e.target.value)}
                      />
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="commonBase mb-4">
            <h6 className="mb-3">Add GHG Key</h6>
            <div className="additembox groupBordr">
              <Dropdown>
                <Dropdown.Toggle
                  variant="success"
                  id="dropdown-basic"
                  style={{ height: "100%" }}
                >
                  {ghgData ? JSON.parse(ghgData)?.key : "Select GHG Key"}
                </Dropdown.Toggle>

                <Dropdown.Menu
                  style={{
                    maxHeight: "250px",
                    overflowY: "auto",
                  }}
                >
                  {sortedData?.map((con) => (
                    <OverlayTrigger
                      key={con.id}
                      placement="top"
                      overlay={
                        <Tooltip
                          id={`tooltip-${con.id}`}
                          style={{ fontSize: "18px" }}
                        >
                          {con?.value}
                        </Tooltip>
                      }
                    >
                      <Dropdown.Item
                        as="button"
                        style={{ height: "100%" }}
                        onClick={() => setGhgData(JSON.stringify(con))}
                      >
                        {`(${con.key})`}
                      </Dropdown.Item>
                    </OverlayTrigger>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
              <input
                type="text"
                className="form-control"
                placeholder="Add GHG Key"
                value={ghgData ? JSON.parse(ghgData)?.value : ""}
                disabled
              />
            </div>
          </div>
          <div className="commonBase mb-4">
            <div className="col-md-12">
              <h5 className="mb-3">Transport Emission</h5>
              {emissionData.map((entry, index) => (
                <div className="row align-items-center" key={index}>
                  {/* Transport Type */}
                  <div className="col-md-4 d-flex align-items-center">
                    <label className="m-2" style={{ fontWeight: "bold" }}>
                      Transport Type:
                    </label>
                    <select
                      className="poEdit"
                      name="transport_type"
                      value={entry?.transport_type}
                      style={{ maxWidth: "200px", width: "100%" }}
                      onChange={(e) => handleTransportEmission(index, e)}
                      id="transport_type"
                    >
                      <option value="">Select Transport Type</option>
                      {TRANSPORT_TYPE.map((fuelType, idx) => (
                        <option
                          value={fuelType}
                          key={idx}
                          selected={fuelType === entry?.transport_type}
                        >
                          {t(fuelType)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Fuel Type */}
                  <div className="col-md-4 d-flex align-items-center">
                    <label className="m-2" style={{ fontWeight: "bold" }}>
                      Fuel Type:
                    </label>
                    <select
                      className="poEdit"
                      name="transport_fuel"
                      value={entry?.transport_fuel}
                      style={{ maxWidth: "200px", width: "100%" }}
                      id="transport_fuel"
                      onChange={(e) => handleTransportEmission(index, e)}
                    >
                      <option value="">Select Fuel Type</option>
                      {FUEL_TYPE.map((fuelType, idx) => (
                        <option
                          value={fuelType}
                          key={idx}
                          selected={fuelType === entry?.transport_fuel}
                        >
                          {t(fuelType)}
                        </option>
                      ))}
                    </select>
                  </div>

                  {/* Distance of Transport */}
                  <div className="col-md-4 d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <label
                        htmlFor={`transport-distance-${index}`}
                        className="m-2 form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        Distance
                      </label>
                      <input
                        type="text"
                        name="transport_distance"
                        id={`transport-distance`}
                        value={entry?.transport_distance}
                        onChange={(e) => handleTransportEmission(index, e)}
                        className="border-0 border-bottom"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "150px",
                          marginRight: "5px",
                        }}
                      />
                      <span className="m-2">Km</span>
                    </div>

                    {/* Remove specific entry if more than 1 */}
                    {index > 0 && (
                      <i
                        className="fa fa-circle-minus"
                        style={{ cursor: "pointer", marginRight: "10px" }}
                        onClick={() => handleRemoveTransport(index)} // Remove by index
                      ></i>
                    )}
                    {/* Always show the "+" button */}
                    <i
                      className="fa fa-circle-plus"
                      style={{ cursor: "pointer" }}
                      onClick={handleAddTransport} // Add new transport entry
                    ></i>
                  </div>
                </div>
              ))}
            </div>
          </div>
          {/* <div className="commonBase mb-4">
            <div className="col-md-12">
              <h5 className="mb-3">Waste Packaging Material </h5>
              {wasteData.map((entry, index) => (
                <div className="row align-items-center" key={index}>
                  <div className="col-md-4 d-flex align-items-center">
                    <label className="m-2" style={{ fontWeight: "bold" }}>
                      Material Type:
                    </label>
                    <select
                      className="poEdit"
                      style={{ maxWidth: "200px", width: "100%" }}
                      name="material_type"
                      value={entry?.material_type}
                      id="material_type"
                      onChange={(e) => handleWasteMaterial(index, e)}
                    >
                      <option value="">Select Material Type</option>
                      {MATERIAL_TYPE.map((materialType, index) => (
                        <option
                          value={materialType}
                          key={index}
                          selected={materialType === entry?.material_type}
                        >
                          {t(materialType)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-md-4 d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      <label
                        htmlFor={`transport-distance`}
                        className="m-2 form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        Quantity
                      </label>
                      <input
                        type="number"
                        id={`waste-quantity`}
                        className="border-0 border-bottom"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          width: "150px",
                          marginRight: "5px",
                        }}
                        name="quantity"
                        value={entry?.quantity}
                        onChange={(e) => handleWasteMaterial(index, e)}
                      />
                      <span className="m-2">Kg</span>
                    </div>
                  </div>
                  <div className="col-md-4 d-flex align-items-center">
                    <div className="d-flex align-items-center">
                      {index > 0 && (
                        <i
                          className="fa fa-circle-minus"
                          style={{ cursor: "pointer", marginRight: "10px" }}
                          onClick={() => handleRemoveWaste(index)}
                        ></i>
                      )}
                      <i
                        className="fa fa-circle-plus"
                        style={{ cursor: "pointer" }}
                        onClick={handleAddWaste}
                      ></i>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
          {/* <div className="commonBase mb-3">
            <h5>{t("quality_questions")}</h5>
            {purchadeOrderData?.PurchaseQualityControls?.map((d, i) => (
              <div className="qualityBase" key={i}>
                <p>{d?.QualityControl?.text}</p>
                <div className="radioline invBasis">
                  <>
                    <div className="invLft" style={{ marginRight: "5px" }}>
                      <input
                        type="radio"
                        id={`test1_${d?.QualityControl?.id}`}
                        value="Yes"
                        checked={
                          allData
                            ? allData[d?.QualityControl?.id]?.answer === "Yes"
                            : d?.answer === "Yes"
                        }
                        name={`name${d?.QualityControl?.id}`}
                        onChange={(e) => handleToggle(e, d?.QualityControl?.id)}
                      />
                      <label htmlFor={`test1_${d?.QualityControl?.id}`}>
                        Yes
                      </label>
                    </div>
                    <div className="invrgt">
                      <input
                        type="radio"
                        id={`test2_${d?.QualityControl?.id}`}
                        value="No"
                        checked={
                          allData
                            ? allData[d?.QualityControl?.id]?.answer === "No"
                            : d?.answer === "No"
                        }
                        name={`name${d?.QualityControl?.id}`}
                        onChange={(e) => handleToggle(e, d?.QualityControl?.id)}
                      />
                      <label htmlFor={`test2_${d?.QualityControl?.id}`}>
                        No
                      </label>
                    </div>
                  </>
                </div>
              </div>
            ))}
          </div> */}

          <div className="commonBase mb-4">
            <div className="col-md-12">
              <h5 className="mb-3">Order Log</h5>
              <Link to="javascript:void(0)" onClick={() => setLogs(true)}>
                <i className="fa fa-history" aria-hidden="true"></i>
              </Link>
            </div>
          </div>

          <div className="commonBase mb-4">
            <h5 className="mb-3">Order Status</h5>

            {["radio"].map((type) => (
              <div key={`OrderStatus`} className="additembox adnewbox">
                {_CHECK_PERMISION("Orders") &&
                  !(
                    _CHECK_PERMISION("PastOrder Approved with Issues") ||
                    _CHECK_PERMISION("PastOrder Approved") ||
                    _CHECK_PERMISION("PastOrder Received with Issues") ||
                    _CHECK_PERMISION("PastOrder Received")
                  ) && (
                    <>
                      <Form.Check
                        reverse
                        label="Created"
                        name="OrderStatus"
                        type={type}
                        id={`Created`}
                        checked={status === "Created"}
                        onChange={onStatus}
                        value={"Created"}
                      />
                    </>
                  )}
                {_CHECK_PERMISION("Orders") &&
                  !(
                    _CHECK_PERMISION("PastOrder Approved with Issues") ||
                    _CHECK_PERMISION("PastOrder Approved")
                  ) && (
                    <>
                      <Form.Check
                        reverse
                        label="Received with comments"
                        name="OrderStatus"
                        type={type}
                        id={`ReceivedWithIssues`}
                        checked={status === "Received,comments"}
                        onChange={onStatus}
                        value={"Received,comments"}
                      />
                      <Form.Check
                        reverse
                        label="Received"
                        name="OrderStatus"
                        type={type}
                        id={`Received`}
                        checked={status === "Received"}
                        onChange={onStatus}
                        value={"Received"}
                      />
                    </>
                  )}
                {_CHECK_PERMISION("Orders") &&
                  !(
                    _CHECK_PERMISION("PastOrder Received with Issues") ||
                    _CHECK_PERMISION("PastOrder Received")
                  ) && (
                    <>
                      <Form.Check
                        reverse
                        label="Approved with comments"
                        name="OrderStatus"
                        type={type}
                        id={`ApprovedWithIssues`}
                        checked={status === "Approved,comments"}
                        onChange={onStatus}
                        value={"Approved,comments"}
                      />
                      <Form.Check
                        reverse
                        label="Approved"
                        name="OrderStatus"
                        type={type}
                        id={`Approved`}
                        checked={status === "Approved"}
                        onChange={onStatus}
                        value={"Approved"}
                      />
                    </>
                  )}
                {_CHECK_PERMISION("Orders") &&
                  !(
                    _CHECK_PERMISION("PastOrder Approved with Issues") ||
                    _CHECK_PERMISION("PastOrder Approved") ||
                    _CHECK_PERMISION("PastOrder Received with Issues") ||
                    _CHECK_PERMISION("PastOrder Received")
                  ) && (
                    <>
                      <Form.Check
                        reverse
                        label="Rejected"
                        name="OrderStatus"
                        type={type}
                        id={`Rejected`}
                        checked={status === "Rejected"}
                        onChange={onStatus}
                        value={"Rejected"}
                      />
                    </>
                  )}
                {_CHECK_PERMISION("PastOrder Approved with Issues") &&
                  _CHECK_PERMISION("PastOrder Approved") &&
                  _CHECK_PERMISION("PastOrder Received with Issues") &&
                  _CHECK_PERMISION("PastOrder Received") &&
                  _CHECK_PERMISION("Orders") &&
                  _CHECK_PERMISION("Configuration") &&
                  _CHECK_PERMISION("Invoices") &&
                  _CHECK_PERMISION("Products") &&
                  _CHECK_PERMISION("Suppliers") &&
                  _CHECK_PERMISION("Reports") &&
                  _CHECK_PERMISION("Business Unit") &&
                  _CHECK_PERMISION("Department") &&
                  _CHECK_PERMISION("Users") && (
                    <>
                      <Form.Check
                        reverse
                        label={t("created")}
                        name="OrderStatus"
                        type={type}
                        id={`Created`}
                        checked={status === "Created"}
                        onChange={onStatus}
                        value={"Created"}
                      />
                      <Form.Check
                        reverse
                        label={t("receivedWithIssues")}
                        name="OrderStatus"
                        type={type}
                        id={`ReceivedWithIssues`}
                        checked={status === "Received,comments"}
                        onChange={onStatus}
                        value={"Received,comments"}
                      />
                      <Form.Check
                        reverse
                        label={t("received")}
                        name="OrderStatus"
                        type={type}
                        id={`Received`}
                        checked={status === "Received"}
                        onChange={onStatus}
                        value={"Received"}
                      />
                      <Form.Check
                        reverse
                        label={t("approvedWithIssues")}
                        name="OrderStatus"
                        type={type}
                        id={`ApprovedWithIssues`}
                        checked={status === "Approved,comments"}
                        onChange={onStatus}
                        value={"Approved,comments"}
                      />
                      <Form.Check
                        reverse
                        label={t("approved")}
                        name="OrderStatus"
                        type={type}
                        id={`Approved`}
                        checked={status === "Approved"}
                        onChange={onStatus}
                        value={"Approved"}
                      />
                      <Form.Check
                        reverse
                        label={t("rejected")}
                        name="OrderStatus"
                        type={type}
                        id={`Rejected`}
                        checked={status === "Rejected"}
                        onChange={onStatus}
                        value={"Rejected"}
                      />
                    </>
                  )}
              </div>
            ))}
          </div>

          <div className="mb-3">
            <div
              className="commonBase d-flex justify-content-between px-3"
              onClick={toggleAccordion}
              style={{ cursor: "pointer" }}
            >
              <div>
                <h5>Accounting Information</h5>
              </div>
              <div>
                {isAccordionOpen ? (
                  <i className="fa fa-chevron-up"></i>
                ) : (
                  <i className="fa fa-chevron-down"></i>
                )}
              </div>
            </div>

            {isAccordionOpen && (
              <div className="poTable respTable aiTable pt-0">
                <table>
                  <thead>
                    <tr>
                      <th>
                        {departmentId ? (
                          <>
                            <span>Department Unit</span>
                            <br></br> <span>Accounting Key</span>
                          </>
                        ) : (
                          <>
                            <span>Operator Unit</span>
                            <br></br> <span>Accounting Key</span>
                          </>
                        )}
                      </th>

                      {accountingInformation?.length > 0
                        ? accountingInformation[0]?.accountDimension
                            ?.GLFieldName && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.GLFieldName
                              }
                            </th>
                          )
                        : null}

                      {accountingInformation?.length > 0
                        ? accountingInformation[0]?.accountDimension
                            ?.dimension2 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension2FieldName
                              }
                            </th>
                          )
                        : null}
                      {accountingInformation?.length > 0
                        ? accountingInformation[0]?.accountDimension
                            ?.dimension3 && (
                            <th>
                              {" "}
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension3FieldName
                              }
                            </th>
                          )
                        : null}
                      {accountingInformation?.length > 0
                        ? accountingInformation[0]?.accountDimension
                            ?.dimension4 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension4FieldName
                              }
                            </th>
                          )
                        : null}
                      {accountingInformation?.length > 0
                        ? accountingInformation[0]?.accountDimension
                            ?.dimension5 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension5FieldName
                              }
                            </th>
                          )
                        : null}
                      {accountingInformation?.length > 0
                        ? accountingInformation[0]?.accountDimension
                            ?.dimension6 && (
                            <th>
                              {
                                accountingInformation[0]?.accountDimension
                                  ?.Dimension6FieldName
                              }
                            </th>
                          )
                        : null}
                      <th>UNSPSC</th>
                      <th>Quantity</th>
                      <th>Amount</th>
                      <th>Currency</th>
                      <th>VAT</th>
                      <th>User Accounting Key</th>
                    </tr>
                  </thead>
                  <tbody>
                    {accountingInformation.length
                      ? accountingInformation.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                {accoutingInfoType === "businessUnit"
                                  ? item?.PastOrder?.Department?.BusinessUnit
                                      ?.accountingKey
                                  : item?.PastOrder?.Department?.accountingKey}
                              </td>
                              <td>
                                {item?.accountDimension?.GL
                                  ? item?.accountDimension?.GL?.key
                                  : "----"}
                              </td>
                              {item?.accountDimension?.dimension2 ? (
                                <td>{item?.accountDimension?.dimension2}</td>
                              ) : (
                                ""
                              )}
                              {item?.accountDimension?.dimension3 ? (
                                <td>{item?.accountDimension?.dimension3}</td>
                              ) : (
                                ""
                              )}
                              {item?.accountDimension?.dimension4 ? (
                                <td>{item?.accountDimension?.dimension4}</td>
                              ) : (
                                ""
                              )}
                              {item?.accountDimension?.dimension5 ? (
                                <td>{item?.accountDimension?.dimension5}</td>
                              ) : (
                                ""
                              )}
                              {item?.accountDimension?.dimension6 ? (
                                <td>{item?.accountDimension?.dimension6}</td>
                              ) : (
                                ""
                              )}
                              <OverlayTrigger
                                placement="top"
                                overlay={
                                  <Tooltip
                                    id="tooltip"
                                    style={{ fontSize: "10px" }}
                                  >
                                    {item?.unspscSegment
                                      ? item?.unspscSegment?.SegmentTitle
                                      : item?.unspscFamily
                                      ? item?.unspscFamily?.FamilyTitle
                                      : item?.unspscClass
                                      ? item?.unspscClass?.ClassTitle
                                      : item?.unspscCommodity?.CommodityTitle}
                                  </Tooltip>
                                }
                              >
                                <td>{item?.unspsc ? item?.unspsc : "----"}</td>
                              </OverlayTrigger>

                              <td>
                                {item?.totalQty ? item?.totalQty : "----"}
                              </td>
                              <td>
                                {item?.totalSalePrice
                                  ? item?.totalSalePrice
                                  : "----"}
                              </td>

                              <td>
                                {item?.currencyType
                                  ? item?.currencyType
                                  : "----"}
                              </td>
                              <td>
                                {item?.VATpercent
                                  ? `${item?.VATpercent} %`
                                  : "----"}
                              </td>

                              <td>{"----"}</td>
                            </tr>
                          );
                        })
                      : null}
                  </tbody>
                </table>
              </div>
            )}
          </div>

          <button className="commonButton mb-3" onClick={onUpdate}>
            Save
          </button>
        </div>

        <Modal
          size="lg"
          show={logs}
          onHide={handleCloseLogs}
          dialogClassName="custom-modal-size"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <h4 className="mb-3">All Logs</h4>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Nav
              fill
              variant="tabs"
              defaultActiveKey={activeTab}
              onSelect={handleSelect}
              className="navTb"
            >
              {/* <Nav.Item>
                <Nav.Link eventKey="link-1">QC Status</Nav.Link>
              </Nav.Item> */}
              <Nav.Item>
                <Nav.Link eventKey="link-2">Comment Status</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-3">Order Logs</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item>
                <Nav.Link eventKey="link-4">Quantity Logs</Nav.Link>
              </Nav.Item> */}
              <Nav.Item>
                <Nav.Link eventKey="link-5">Operator Unit Logs</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-6">GHG Key Logs</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="link-7">Delivery Date & Time Logs</Nav.Link>
              </Nav.Item>
            </Nav>
            {activeTab === "link-1" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      {/* <th>User</th> */}
                      <th>Question</th>
                      <th>Answer</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {allLogs?.SelectedPastOrderQualityControls?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )?.map((s) => (
                        <tr>
                          <td data-label="Date and Time">
                            {/* {format(addOneDayToDate(s?.createdAt), 'MM-dd-yyyy')}, */}
                            {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          {/* <td data-label="User">
                            {s?.User.firstName} {s?.User.lastName}
                          </td> */}
                          <td data-label="Question">
                            {s?.QualityControl?.text}
                          </td>
                          <td
                            data-label="Answer"
                            style={{
                              color: s?.answer === "Yes" ? "green" : "red",
                            }}
                          >
                            {s?.answer}&nbsp;
                          </td>
                        </tr>
                      ))}
                    </>
                  </tbody>
                </table>
              </div>
            )}
            {activeTab === "link-2" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      <th>User</th>
                      <th>Comment</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {allLogs?.commentPurchaseLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.updatedAt) - new Date(a.updatedAt)
                        )
                        ?.map((s) => (
                          <tr>
                            <td data-label="Date and Time">
                              {moment(s?.createdAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label="User">
                              {s?.User.firstName} {s?.User.lastName}
                            </td>
                            <td data-label="Comment">{s?.comments}</td>
                          </tr>
                        ))}
                    </>
                  </tbody>
                </table>
              </div>
            )}
            {activeTab === "link-3" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      <th>User</th>
                      <th>Order Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {pastOrderList?.map((d) => ( */}
                    <>
                      {allLogs?.orderStatusPurchaseLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.updatedAt) - new Date(a.updatedAt)
                        )
                        ?.map((s) => (
                          <tr>
                            <td data-label="Date and Time">
                              {/* {format(addOneDayToDate(s?.createdAt), 'MM-dd-yyyy')}, */}
                              {moment(s?.createdAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label="User">
                              {s?.User.firstName} {s?.User.lastName}
                            </td>
                            <td data-label="orderStatus">{s?.orderStatus}</td>
                          </tr>
                        ))}
                    </>
                    {/* ))} */}
                  </tbody>
                </table>
              </div>
            )}
            {activeTab === "link-4" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      <th>User</th>
                      <th>Product Name</th>
                      <th>Quantity</th>
                      <th>Received Quantity</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {pastOrderList?.map((d) => ( */}
                    <>
                      {allLogs?.QuantityLogs?.sort(
                        (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
                      )?.map((s) => (
                        <tr>
                          <td data-label="Date and Time">
                            {/* {format(addOneDayToDate(s?.createdAt), 'MM-dd-yyyy')}, */}
                            {moment(s?.createdAt).format("DD-MM-YYYY,HH:mm:ss")}
                          </td>
                          <td data-label="User">
                            {s?.User.firstName} {s?.User.lastName}
                          </td>
                          <td data-label="item">{s?.item}</td>
                          <td data-label="quantity">{s?.quantity}</td>
                          <td data-label="receivedQuantity">
                            {s?.receivedQuantity}
                          </td>
                        </tr>
                      ))}
                    </>
                    {/* ))} */}
                  </tbody>
                </table>
              </div>
            )}
            {activeTab === "link-5" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      <th>User</th>
                      <th>Operator Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {pastOrderList?.map((d) => ( */}
                    <>
                      {allLogs?.businessPurchaseLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.updatedAt) - new Date(a.updatedAt)
                        )
                        ?.map((s) => (
                          <tr>
                            <td data-label="Date and Time">
                              {/* {format(addOneDayToDate(s?.createdAt), 'MM-dd-yyyy')}, */}
                              {moment(s?.updatedAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label="User">
                              {s?.User?.firstName} {s?.User?.lastName}
                            </td>
                            <td data-label="item">{s?.BusinessUnit?.name}</td>
                          </tr>
                        ))}
                    </>
                    {/* ))} */}
                  </tbody>
                </table>
              </div>
            )}
            {activeTab === "link-6" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      <th>User</th>
                      <th>GHG Key</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {pastOrderList?.map((d) => ( */}
                    <>
                      {allLogs?.ghgPurchaseLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.updatedAt) - new Date(a.updatedAt)
                        )
                        ?.map((s) => (
                          <tr>
                            <td data-label="Date and Time">
                              {/* {format(addOneDayToDate(s?.createdAt), 'MM-dd-yyyy')}, */}
                              {moment(s?.updatedAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label="User">
                              {s?.User?.firstName} {s?.User?.lastName}
                            </td>
                            <td data-label="item">{s?.MasterGHG?.key}</td>
                          </tr>
                        ))}
                    </>
                    {/* ))} */}
                  </tbody>
                </table>
              </div>
            )}
            {activeTab === "link-7" && (
              <div className="dbMaintable respTable">
                <table>
                  <thead>
                    <tr>
                      <th>Date and Time</th>
                      <th>User</th>
                      <th>Deliveri Date & Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    <>
                      {allLogs?.deliveryPurchaseLogs
                        ?.sort(
                          (a, b) =>
                            new Date(b.updatedAt) - new Date(a.updatedAt)
                        )
                        ?.map((s) => (
                          <tr>
                            <td data-label="Date and Time">
                              {moment(s?.updatedAt).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                            <td data-label="User">
                              {s?.User?.firstName} {s?.User?.lastName}
                            </td>
                            <td data-label="item">
                              {moment(s?.deliveryDateTime).format(
                                "DD-MM-YYYY,HH:mm:ss"
                              )}
                            </td>
                          </tr>
                        ))}
                    </>
                  </tbody>
                </table>
              </div>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Purchaseorderdetail;
